import React, { useState } from 'react';
import { Tabs } from 'antd';
import styled from 'styled-components';

import Label from 'components/Text/Text';

interface IPhonePreviewWrapperProps {
  heading?: JSX.Element | string;
  backgroundImage?: string | File;
  backgroundColor?: string;
  children?: JSX.Element;
  icon?: JSX.Element;
  alignItems?: string;
  tabs?: { label: string; render: JSX.Element; dataTestId?: string }[];
  className?: string;
  description?: string;
}

const PhonePreviewWrapper: React.FC<IPhonePreviewWrapperProps> = React.memo(
  ({ heading, tabs, icon, children, className, description }) => {
    const [currentTab, setCurrentTab] = useState('0');

    return (
      <PhonePreviewStyled className={className}>
        <section>
          <div className="phone-preview-content">
            <div className="phone-generic-wrapper">
              <div className="phone-screen">
                {(heading || icon) && (
                  <CampaignNameStyled>
                    {icon}
                    {heading || ''}
                  </CampaignNameStyled>
                )}
                {tabs?.[currentTab]?.render || children}
              </div>
            </div>
          </div>
        </section>
        {tabs && (
          <div className="tab-view">
            <Tabs
              activeKey={currentTab}
              onChange={setCurrentTab}
              items={tabs.map((_, index) => ({
                label: <label data-testid={_.dataTestId}>{_.label}</label>,
                key: index.toString()
              }))}
            />
          </div>
        )}
        <Label className="phone-description">{description || ''}</Label>
      </PhonePreviewStyled>
    );
  }
);

export default PhonePreviewWrapper;

export const PHONE_SIZE = {
  WIDTH: 250
};

export const COMMON_COLOR = {
  GREY: '#262626',
  WHITE: '#fff',
  GREY_7: '#BFBFBF'
};

export const RADIUS_BUTTON = {
  LARGE: 25
};

const PhonePreviewStyled = styled.div`
  --scale: 1.5;

  /* width */
  .phone-screen::-webkit-scrollbar {
    width: calc(10px / var(--scale));
  }

  // for firefox
  .phone-screen {
    scrollbar-width: calc(10px / var(--scale));
    scrollbar-track-color: transparent;
  }

  .phone-screen::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar:hover {
    opacity: 1;
  }

  .phone-screen:hover::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Track */
  *::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  *::-webkit-scrollbar-thumb {
    background: transparent;
  }

  /* Handle on hover */
  *::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  width: ${PHONE_SIZE.WIDTH}px;
  max-width: 100%;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: flex-end;

  section {
    width: 100%;
  }

  .phone-preview-content {
    background: ${COMMON_COLOR.GREY};
    width: 100%;
    padding-top: 200%;
    border-radius: ${RADIUS_BUTTON.LARGE}px;
    overflow-y: hidden;
    position: relative;
  }

  .phone-generic-wrapper {
    padding: 32px 8px;
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    background-size: cover;
  }

  .phone-screen {
    background-color: ${COMMON_COLOR.WHITE};
    height: 100%;
    overflow-y: overlay;
    overflow-x: hidden;
    position: relative;
  }

  .tab-view {
    display: flex;
    margin-top: 16px;
    width: 100%;
    justify-content: center;
  }

  .phone-description {
    margin-top: 16px;
    text-align: center;
  }

  .ant-tabs-tab {
    font-size: calc(18px / var(--scale));
  }

  .ant-table-body {
    font-size: calc(14px / var(--scale));
  }
`;

export const CampaignNameStyled = styled.h2`
  background: #4593cd;
  color: ${COMMON_COLOR.WHITE};
  text-align: center;
  font-size: 12px;
  padding: 10px;
  margin-bottom: 0;
  position: relative;
  height: calc(56px / var(--scale));

  svg {
    position: absolute;
    left: 5px;
    top: 50%;
    width: 16px;
    height: 16px;
    margin: 0 8px;
    transform: translateY(-50%);
  }
`;
